import { render, staticRenderFns } from "./SelectionAction.vue?vue&type=template&id=10ae83f8&scoped=true&functional=true&"
import script from "./SelectionAction.vue?vue&type=script&lang=js&"
export * from "./SelectionAction.vue?vue&type=script&lang=js&"
import style0 from "./SelectionAction.vue?vue&type=style&index=0&id=10ae83f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "10ae83f8",
  null
  
)

export default component.exports